import React from 'react';
import { useNavigate } from 'react-router-dom';

const DEALS = [
  { from:'JFK', to:'LAX', fromCity:'New York', toCity:'Los Angeles', price:89,  was:234, drop:62, seats:3, tag:'🔥 Flash',  col:'from-blue-700 to-cyan-600' },
  { from:'MIA', to:'ORD', fromCity:'Miami',    toCity:'Chicago',     price:71,  was:158, drop:55, seats:5, tag:'⚡ Sale',   col:'from-cyan-700 to-blue-600' },
  { from:'ATL', to:'LAS', fromCity:'Atlanta',  toCity:'Las Vegas',   price:79,  was:198, drop:60, seats:2, tag:'🚨 Last',  col:'from-blue-800 to-cyan-500' },
  { from:'BOS', to:'DEN', fromCity:'Boston',   toCity:'Denver',      price:83,  was:169, drop:51, seats:8, tag:'💰 Deal',  col:'from-cyan-600 to-blue-700' },
  { from:'DAL', to:'SFO', fromCity:'Dallas',   toCity:'San Francisco',price:94, was:181, drop:48, seats:4, tag:'🔥 Flash', col:'from-blue-700 to-indigo-600'},
  { from:'SEA', to:'PHX', fromCity:'Seattle',  toCity:'Phoenix',     price:67,  was:156, drop:57, seats:6, tag:'⚡ Sale',  col:'from-indigo-600 to-cyan-500'},
];

export default function TodaysDeals() {
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];
  return (
    <section className="py-12 sm:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 gap-3">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <span className="text-xs font-bold text-blue-700 uppercase tracking-widest bg-blue-100 px-3 py-1 rounded-full">🔥 Today's Price Drops</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-black text-gray-900">Biggest Deals Right Now</h2>
            <p className="text-gray-500 text-sm mt-1">Scanned across 150+ airlines — prices valid while seats last</p>
          </div>
          <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-xl px-4 py-2 shadow-sm">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
            <span className="text-xs font-semibold text-gray-600">Updated 12 mins ago</span>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {DEALS.map(d => (
            <div key={d.from+d.to} onClick={() => navigate('/flights?origin='+d.from+'&destination='+d.to+'&date='+today+'&adults=1&tripType=oneway&class=economy&passengers=1')}
              className="group bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1">
              <div className={'bg-gradient-to-r '+d.col+' p-4 sm:p-5 text-white'}>
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-bold bg-white/20 px-2.5 py-1 rounded-full">{d.tag}</span>
                  <span className={'text-xs font-bold px-2.5 py-1 rounded-full '+(d.seats<=3?'bg-red-500':'bg-white/20')}>{d.seats<=3?'🚨 Only '+d.seats+' left':d.seats+' seats left'}</span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="text-center"><p className="text-2xl font-black">{d.from}</p><p className="text-white/70 text-xs">{d.fromCity}</p></div>
                  <div className="flex-1 flex flex-col items-center gap-1 px-3">
                    <div className="w-full flex items-center gap-1"><div className="h-px flex-1 bg-white/40"/><span className="text-base">✈</span><div className="h-px flex-1 bg-white/40"/></div>
                    <span className="text-white/60 text-xs">Non-stop</span>
                  </div>
                  <div className="text-center"><p className="text-2xl font-black">{d.to}</p><p className="text-white/70 text-xs">{d.toCity}</p></div>
                </div>
              </div>
              <div className="p-4 flex items-center justify-between">
                <div>
                  <div className="flex items-baseline gap-2">
                    <span className="text-2xl font-black text-gray-900">${d.price}</span>
                    <span className="text-xs text-gray-400 line-through">${d.was}</span>
                  </div>
                  <span className="text-xs font-bold text-green-600">You save ${d.was-d.price} ({d.drop}% off)</span>
                </div>
                <button className="bg-gradient-to-r from-blue-700 to-cyan-500 text-white text-xs font-bold px-4 py-2 rounded-xl group-hover:shadow-lg transition-all">Grab Deal →</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
